<p>dealer-finance works!</p>
